import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { StoreState } from "../../redux/reduxTypes";
import { UserSession } from "../../types/state.types";
import Footer from "../footer";
import Header from "../header";
import MenuCooperado from "../menuCooperado";
import { MainContainer, PageContent, PageWrapper } from "./styled";

type StaticContentProps = {
  logged: boolean,
  printing: boolean,
}

function StaticContent({ logged, printing }: StaticContentProps) {
  const dadosCooperado: UserSession | undefined
  = useSelector<StoreState, UserSession | undefined>(state => state.loginState.userData);
  
  return (
  <PageWrapper className={printing ? "imprimir" : ""}>
    <MainContainer className={printing ? "imprimir" : ""}>
      {!printing ? <Header logged={logged} /> : <></>}

      <PageContent id={logged && !printing ? "": "naoLogado"}>
        {logged && !printing ? <MenuCooperado id="menuCima"/>: <></>}
        <div>
          {logged
          ? <h3>
              <strong>COOPERADO(A):&#9;</strong>{dadosCooperado?.Nome}
              <strong style={{ marginLeft: '8px' }}>MATRICULA:&#9;</strong>{dadosCooperado?.Matricula}
            </h3>
          : <></>}
          <Outlet />
        </div>
        
        {logged && !printing ? <MenuCooperado id="menuBaixo"/>: <></>}
      </PageContent>

      <Footer />
    </MainContainer>
  </PageWrapper>
  );
}

export default StaticContent;
